import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "./loginSlice";
import permissionDataReducer from "./userSlice";
import cmdDataReducer from "./cmsSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    userPermission: permissionDataReducer,
    cmsData: cmdDataReducer,
  },
});

export default store;
